export default __webpack_public_path__ + "static/media/AIC LOGO GRAPHIC BLACK.e5a9cb90.svg";